import { render, staticRenderFns } from "./CrmFunnelFormUi.vue?vue&type=template&id=c5a06e46&scoped=true&lang=pug&"
import script from "./CrmFunnelFormUi.vue?vue&type=script&lang=js&"
export * from "./CrmFunnelFormUi.vue?vue&type=script&lang=js&"
import style0 from "./CrmFunnelFormUi.vue?vue&type=style&index=0&id=c5a06e46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a06e46",
  null
  
)

export default component.exports